import React, { PureComponent } from 'react';
import { withSize } from 'react-sizeme';
import * as d3Shape from 'd3-shape';
import isEqual from 'lodash.isequal';

import './HalfDonut.styl';

const d3 = {
  ...d3Shape
};

const translate = (x, y) => `translate(${x},${y})`;

function getChartHeight({ height, width }) {
  return Math.min(height, width / 2);
}

class HalfDonut extends PureComponent {
  componentDidMount() {
    this.updateGenerators();
  }

  componentDidUpdate(prevProps) {
    if (this.props.size.height !== prevProps.size.height || !isEqual(this.props.data, prevProps.data)) {
      this.updateGenerators();
    }
  }

  updateGenerators() {
    const { size } = this.props;

    this.chartHeight = getChartHeight(size);

    this.arc = d3.arc()
      .innerRadius(this.chartHeight - (this.chartHeight / 2))
      .outerRadius(this.chartHeight)

    this.pie = d3.pie()
      .value(d => d.seats)
      .padAngle(.02)
      .startAngle(-Math.PI / 2)
      .endAngle(Math.PI / 2)
      .sort(null);

    this.forceUpdate();
  }

  render() {
    const { size, data } = this.props;
    const { width } = size;

    if (!this.arc) {
      return null;
    }

    const pies = this.pie(data);

    return (
      <svg width={width} height={this.chartHeight} className="halfdonut">
        <g transform={translate(width / 2, this.chartHeight)}>
          {pies.map(p => (
            <path
              key={`donutpie_${p.data.name}`}
              d={this.arc(p)}
              fill={p.data.color}
            />
          ))}
        </g>
      </svg>
    );
  }
}

export default withSize({ monitorHeight: true })(HalfDonut);
